@if (params.billingOnly(params.data)) {
  <div class="flex justify-end">
    <a
      panButton
      color="info"
      [routerLink]="['/home', 'manage', 'branch', params.data.id]"
      [queryParams]="{ subpage: 'billing' }"
      data-testid="bl-branch-billing"
    >
      Billing
    </a>
  </div>
}

<div class="flex gap-2" [class.hidden]="params.billingOnly(params.data)">
  <app-pan-button
    color="info"
    icon="edit"
    (click)="params.editCallback(params.data)"
    matTooltip="Edit Branch"
    data-testid="bl-branch-edit"
  ></app-pan-button>

  <app-pan-button fill="outline" color="info" [matMenuTriggerFor]="menu" icon="more_vert">
    <mat-menu #menu="matMenu">
      <a
        mat-menu-item
        [routerLink]="['/home', 'manage', 'branch', params.data.id]"
        [queryParams]="{ subpage: 'billing' }"
        panRole
        [roles]="['admin', 'branch-manager', 'branch-owner', 'market-manager', 'self-service', 'location-manager']"
      >
        <span>Billing</span>
      </a>

      <a
        mat-menu-item
        [routerLink]="['/home', 'manage', 'branch', params.data.id]"
        [queryParams]="{ subpage: 'billing-history' }"
        panRole
        [roles]="['admin', 'branch-manager', 'branch-owner']"
      >
        <span>Billing History</span>
      </a>

      <a
        mat-menu-item
        [routerLink]="['/home', 'manage', 'branch', params.data.id]"
        [queryParams]="{ subpage: 'camera-health' }"
        panRole
        [roles]="['admin', 'installer', 'branch-manager', 'branch-owner', 'market-manager']"
      >
        <span>Camera Health</span>
      </a>

      <a
        mat-menu-item
        panRole
        [roles]="['investigator', 'validator', 'admin', 'self-service']"
        [routerLink]="['/home', 'manage', 'branch', params.data.id]"
        [queryParams]="{ subpage: 'identities' }"
      >
        <span>Identities</span>
      </a>

      <a
        mat-menu-item
        panRole
        [roles]="['admin', 'branch-owner', 'branch-manager', 'installer', 'self-service']"
        [routerLink]="['/home', 'manage', 'branch', params.data.id]"
        [queryParams]="{ subpage: 'installer-dashboard' }"
      >
        <span>Installer Dashboard</span>
      </a>

      <a
        mat-menu-item
        [routerLink]="['/home', 'manage', 'branch', params.data.id, 'location']"
        panRole
        [roles]="['admin', 'branch-manager', 'branch-owner']"
      >
        <span>Locations</span>
      </a>

      <a mat-menu-item [routerLink]="['/home', 'manage', 'branch', params.data.id]" [queryParams]="{ subpage: 'shrink' }">
        <span>Shrink</span>
      </a>

      <a
        mat-menu-item
        [routerLink]="['/home', 'manage', 'branch', params.data.id]"
        [queryParams]="{ subpage: 'subscriptions' }"
        panRole
        [roles]="['admin']"
      >
        <span>Subscriptions</span>
      </a>
    </mat-menu>
  </app-pan-button>
</div>
